import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Link from '@dashboard/components/Link';
import Logo from '@dashboard/components/Logo';
import { tracking, useTracking } from '@dashboard/lib/tracking';
import insertScript from '@dashboard/lib/insertScript';
import { isProduction } from '@dashboard/services/env';
import { injectTrackingScript } from '@/dashboard/lib/scriptInjector';

const AuthLayout = ({ children }) => {
  useTracking();
  const location = useLocation();

  // track pageviews
  useEffect(() => {
    tracking.trackPageview();
  }, [location]);

  // load google ads
  useEffect(() => {
    function loadGoogleAds() {
      injectTrackingScript(
        `
        <!-- Google tag (gtag.js) -->
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-ZQ3SPC315S"></script>
        <script>
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-ZQ3SPC315S');
        </script>
      `,
      );
    }

    if (isProduction) {
      loadGoogleAds();
    }
  }, []);

  // load facebook pixel
  useEffect(() => {
    function loadFacebookPixel() {
      insertScript(`
        <!-- Meta Pixel Code -->
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '976736210989373');
        fbq('track', 'PageView');
        <!-- End Meta Pixel Code -->
      `);
    }

    loadFacebookPixel();
    if (isProduction) {
      loadFacebookPixel();
    }
  }, []);

  return (
    <div className={clsx('flex flex-col min-h-screen', {})}>
      <div>
        <div className="ml-4 mt-6">
          <Link href="/">
            <a
              className={`transition-colors no-underline hover:text-chocolate-600 text-xl font-extrabold text-black flex items-center gap-x-2 mr-2`}
            >
              <Logo size={40} />

              <span>Checkout Page</span>
            </a>
          </Link>
        </div>

        <div className={clsx('max-w-lg w-full mx-auto px-4 mt-20')}>{children}</div>
      </div>

      <div className="mt-auto px-4 py-4">
        <div className="md:flex justify-between text-gray-600 text-sm mt-16">
          <p className="pb-4 md:pb-0">
            {new Date().getFullYear()} © Checkout Page. All rights reserved.
          </p>
          <div className="space-x-4">
            <a
              className="hover:text-gray-900 hover:underline"
              href="/terms-of-service"
              target="_blank"
            >
              Terms of Service
            </a>
            <a
              className="hover:text-gray-900 hover:underline"
              href="/privacy-policy"
              target="_blank"
            >
              Privacy policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
